module.exports = __webpack_public_path__ + "media/components/resources/show/resource-show-native-ad/img/version2-5e5a29ff92104463a0bc65472069198c.jpg";